import Vue from 'vue'
import VueRouter from 'vue-router'
import Application from '../views/Application.vue'
import ResetGames from '../views/ResetGames.vue'
import ResetUsers from '../views/ResetUsers.vue'
import WheelOfFortune from '../views/WheelOfFortune.vue'
import CustomNotifications from '../views/CustomNotifications.vue'
import Rules from '../views/Rules.vue'
import Settings from '../views/Settings.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/reset_games',
        name: 'ResetGames',
        component: ResetGames
    },
    {
        path: '/reset_users',
        name: 'ResetUsers',
        component: ResetUsers
    },
    {
        path: '/wheel',
        name: 'WheelOfFortune',
        component: WheelOfFortune
    },
    {
        path: '/customnotifications',
        name: 'CustomNotification',
        component: CustomNotifications
    },
    {
        path: '/rules',
        name: 'Rules',
        component: Rules
    },
    {
        path: '/',
        name: 'Application',
        component: Application,
        children: [
            {
                path: '/:id',
                name: 'Dashboard',
                component: Application
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
